export default "__VITE_ASSET__7boJd7z9__"